import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Select } from 'antd';

const Item = Form.Item
const { TextArea } = Input
const Option = Select.Option

class AddForm extends Component {
  static propTypes = {
    setForm: PropTypes.func.isRequired,
  }

  componentWillMount() {
    this.props.setForm(this.props.form)
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
    }
    return (
      <Form {...formItemLayout}>
        <Item label="角色名称">
          {getFieldDecorator(
            'role_id',
            {}
          )(<Input placeholder="请输入角色名称" />)}
        </Item>
        <Item label="类型">
          {getFieldDecorator('type', { initialValue: 0 })(
            <Select>
              <Option value={0}>系统角色</Option>
              <Option value={1}>用户角色</Option>
            </Select>
          )}
        </Item>
        <Item label="描述">
          {getFieldDecorator('desc', {})(<TextArea rows={4} />)}
        </Item>
      </Form>
    )
  }
}

export default Form.create()(AddForm)
